export { FormattedDate, type FormattedDateProps } from "./FormattedDate";
